import { ANDROID_APP_STORE_URL, IOS_APP_STORE_URL } from '@utils/config';
import { useTranslation } from 'react-i18next';

export const AppStoreButtons = () => {
  const { t } = useTranslation();

  return (
    <div className="redemption-stores">
      <a
        href={IOS_APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t('success_page.app_store')}
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            fill="currentColor"
            d="M17.1 12.3c0-2 1.6-3 1.7-3.1-1-1.5-2.5-1.6-3-1.6-1.3-.1-2.6.8-3.3.8-.7 0-1.8-.8-2.9-.7-1.5 0-2.9.9-3.7 2.2-1.6 2.7-.4 6.8 1.1 9 .7 1.1 1.6 2.2 2.8 2.2 1.1 0 1.5-.7 3-.7 1.3 0 1.8.7 3 .7s2-1.1 2.8-2.2c.8-1.3 1.2-2.5 1.2-2.6-.1 0-2.7-1-2.7-4ZM15 6.2c.6-.8 1.1-1.8 1-2.9-1 .1-2.1.7-2.8 1.4-.6.7-1.2 1.8-1.1 2.8 1.1.1 2.2-.5 2.9-1.3Z"
          />
        </svg>
        <span>
          <small>{t('success_page.get_on')}</small>
          <strong>{t('success_page.app_store')}</strong>
        </span>
      </a>
      <a
        href={ANDROID_APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t('success_page.google_play')}
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            fill="currentColor"
            d="M4 3.1v17.8c0 .7.7 1.1 1.3.7l14-8.9c.5-.3.5-1.1 0-1.4l-14-9C4.7 2 4 2.4 4 3.1Z"
          />
        </svg>
        <span>
          <small>{t('success_page.get_on')}</small>
          <strong>{t('success_page.google_play')}</strong>
        </span>
      </a>
    </div>
  );
};
